module.exports = __webpack_public_path__ + "static/media/link-logo-bolsa.1a10ed3b.png";